module.exports = __webpack_public_path__ + "img/articleComplete.5f713531.svg";